import { ReactNode } from "react";

import { CloseIcon } from "@/assets/icons";
import Tooltip from "@/components/ui/tooltip";

type Props = {
  title: string;
  children?: ReactNode;
  onClose: () => void;
  withCloseButton?: boolean;
};

const SpatialHeader = ({
  title,
  children,
  onClose,
  withCloseButton = true
}: Props) => {
  return (
    <div className="flex flex-col px-4 mt-4">
      <div className="flex flex-row justify-between items-center">
        <h2 className="text-txtHeading font-sans font-bold text-[20px]">
          {title}
        </h2>
        {withCloseButton && (
          <div className="flex gap-3">
            {children}
            <Tooltip content="Close" position="bottom-center">
              <button
                className="bg-transparent cursor-pointer border-0 p-0"
                onClick={onClose}
                aria-label="Close"
                data-testid="btn-header-close"
              >
                <CloseIcon className="fill-dim-gray" />
              </button>
            </Tooltip>
          </div>
        )}
      </div>
    </div>
  );
};

export default SpatialHeader;
